var styleDataHash = "f315801e";
const injectCss = () => {
  var css = `._7USuP,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.DZoda{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;font-size:14px;height:40px;width:100%}[dir] .DZoda{background-color:#fff}[dir=ltr] .DZoda,[dir=rtl] .DZoda{padding-left:20px;padding-right:20px}.DZoda>*{flex:1}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_toggle_default = {
  "fontElementMap": "_7USuP",
  "container": "DZoda"
};
export {
  list_item_toggle_default as default,
  injectCss
};
//# sourceMappingURL=list-item-toggle-scss.js.map
